<template>
    <v-container>

      <v-toolbar  width='1200px' class="toolbarHack213" flat fixed app>
        <a href="https://app.smartpress.co" target="blank"><img
          src="../../assets/logo.png"
          height="50px"
          style="margin:0 30px;"
        /></a>

        <b-nav-item-dropdown 
        v-if="isAuthenticated" 
        right>
        <template slot="button-content">
          <icon name="user-circle"/><strong class="nav-username">{{ user.username }}</strong>
        </template>
        <b-row 

          class="justify-content-md-center" 
          >
          <b-dropdown-item style='width:90% !important' to="/billing"><icon name="Billing"/><span>Billing</span></b-dropdown-item>
          <b-dropdown-item style='width:90%' to="/changePassword"><span  >Change Password</span></b-dropdown-item>
          <b-dropdown-item style='width:90%' to="/signOut"><icon name="sign-out"/><span  >Sign Out</span></b-dropdown-item>
        </b-row>
      </b-nav-item-dropdown>
      </v-toolbar>

      <v-layout>  

      <v-flex v-bind:class= "[$vuetify.breakpoint.smAndDown ? [] : ['d-flex', 'margin-t']]" wrap>
        <v-flex xs12 md7 style="padding-top:20px; height:auto; ">
          <h1>Billing<br/></h1>
          <h4>Smartpress subscription</h4>

          <table>
            <tr>
              <th>Item</th>
              <th>Monthly discount</th>
              <th>Price per month</th>
              <th>Yearly total</th>
            </tr>
            <tr>
              <td>1 x Smartpress core 12 month subscription</td>
              <td style="color:red">-$88</td>
              <td>$12 / month</td>
              <td>$148 / year</td>
            </tr>
            <br/>
            <tr>
              <td>Total due today</td>
              <td></td>
              <td></td>
              <td style="color:green">$12.00 AUD</td>
            </tr>
          </table>

          <v-btn to="/subscriptionPaymentVip" small :disabled="!termsAgreed" style="margin-top:18px;float:right;" >Pay now</v-btn>

          <v-checkbox v-model="termsAgreed" style="float:right"></v-checkbox><span  style="float:right; margin-top:22px; margin-right:8px; ">I have read and agree to Smartpress <b-link style="text-decoration:underline; color:silver" to="../terms">Terms and Conditions</b-link> </span>


          

          <!-- <span v-if="!$vuetify.breakpoint.smAndDown" class="button-group"> -->
          

          <!-- <span v-if="$vuetify.breakpoint.smAndDown" class="button-group">
            <v-flex style="margin-bottom:20px;" d-flex>
              <v-text-field placeholder="Keep up to date" rounded outlined style="background-color:white; height:55px;"></v-text-field>
              <v-btn flatten rounded large color="white" style="border: 2px solid #6C1919; color:#6C1919;font-weight:800;width:100px;height:52px;margin-top:2px; margin-left:-102px;"> SEND</v-btn>
            </v-flex>

            <v-btn href="product.smartpress.co/" depressed color="#FFDFCB" large class="button-padding" flat rounded><span class="orange-button-main button-text">SOLUTIONS</span></v-btn>
            <span style="font-size:9px;font-weight:800;margin:20px;">OR</span>
            <v-btn href="https://www.coinbase.com/earn/eos/lesson/1" depressed style="border: 2px solid #6C1919; color:#6C1919;font-weight:800;" outlined large class="button-padding" target="_blank" flat rounded><span class="button-text">LEARN AND EARN</span></v-btn>
          </span> -->

        </v-flex>
        <v-flex xs12 md5   style=" height:300px;padding:20px;">
          
          
        </v-flex> 
      </v-flex>
    </v-layout>
    </v-container>
</template>


<script>
export default {
  data() {
    return {
      termsAgreed: false,

    }
  }
}
</script>


          <style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid rgba(0,0,0,0.04);
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: rgba(0,0,0,0.04);
}
</style>